import React from "react";

import { pluralize } from "../../../Helpers/StringHelpers";

export interface PluralizeProps {
    count: number;
    oneElementWordForm: string;
    fourElementsWordForm: string;
    fiveElementsWordForm: string;
}

export const Pluralize = (props: PluralizeProps) => (
    <span>
        {pluralize(props.count, [props.oneElementWordForm, props.fourElementsWordForm, props.fiveElementsWordForm])}
    </span>
);
